import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { mountDevTools } from '@src/store/utils/mount-dev-tools';

type State = {
	globalErrorDialogOpen: boolean;
	showPreviousClientDialog: boolean;
};

type Actions = {
	setGlobalErrorDialogOpen: (open: boolean) => void;
	setShowPreviousClientDialog: (open: boolean) => void;
	reset: () => void;
};

const INITIAL_STATE: State = {
	globalErrorDialogOpen: false,
	showPreviousClientDialog: false,
};

const useGlobalUXStore = create<State & Actions>()(
	persist(
		(set) => ({
			...INITIAL_STATE,
			setGlobalErrorDialogOpen: (globalErrorDialogOpen) => set({ globalErrorDialogOpen }),
			setShowPreviousClientDialog: (showPreviousClientDialog) => set({ showPreviousClientDialog }),
			reset: () => set(INITIAL_STATE),
		}),
		{ name: 'book-an-appointment-global-ux' }
	)
);

mountDevTools('globalUXStore', useGlobalUXStore);

export default useGlobalUXStore;
